(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('UiExitHelper', UiExitHelper)

    /** @ngInject */
    function UiExitHelper($q, sweetAlert) {
        const UiExitHelper = {
            canExit: canExit
        };

        return UiExitHelper;

        function canExit(originalData, compareData) {
            let defer = $q.defer();

            let showModal = () => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Você irá perder as alterações que executou',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value)
                        defer.resolve(true);
                    else
                        defer.resolve(false);
                })
            }

            if (originalData && originalData.constructor === Array && compareData && compareData.constructor === Array) {
                let hasDiff = false;

                for (let index = 0; index < originalData.length; index++) {
                    const data = originalData[index];

                    if (compareData[index] && !angular.equals(data, compareData[index])) {
                        // var result = deepDiffMapper.map(data, compareData[index]);
                        // var result2 = getObjectDiff(data, compareData[index]);
                        // console.log('result: ', result);
                        // console.log('result2: ', result2);

                        hasDiff = true;
                        showModal();
                    }
                }

                if (!hasDiff)
                    defer.resolve(true);
            } else {
                if (!angular.equals(originalData, compareData))
                    showModal();
                else
                    defer.resolve(true);
            }

            return defer.promise;
        }

        /*
         * Compare two objects by reducing an array of keys in obj1, having the
         * keys in obj2 as the intial value of the result. Key points:
         *
         * - All keys of obj2 are initially in the result.
         *
         * - If the loop finds a key (from obj1, remember) not in obj2, it adds
         *   it to the result.
         *
         * - If the loop finds a key that are both in obj1 and obj2, it compares
         *   the value. If it's the same value, the key is removed from the result.
         */
        function getObjectDiff(obj1, obj2) {
            const diff = Object.keys(obj1).reduce((result, key) => {
                if (!obj2.hasOwnProperty(key)) {
                    result.push(key);
                } else if (_.isEqual(obj1[key], obj2[key])) {
                    const resultKeyIndex = result.indexOf(key);
                    result.splice(resultKeyIndex, 1);
                }
                return result;
            }, Object.keys(obj2));

            return diff;
        }
    }
}());